'use strict'

import UsuarioService from "@/services/Auth/UsuarioService"
import CartorioService from "@/services/CartorioService"
import store from '@/store'

export async function acessarCartorio (cartorios, userId) {
  userId = parseInt(userId)
  cartorios = Object.freeze(cartorios)

  // verificamos se o user_id enviado é o mesmo da sessao
  // se for o mesmo da sessao, apenas selecionamos o cartorio_id, se não, fazemos login com o outro usuario.
  if (userId !== store.state.auth.usuario.user_id) {
    // solicitamos o novo usuarioA
    const newUser = await UsuarioService.changeMyUser(userId).then(resp => resp.data)

    // gravamos o novo usuario no vuex
    await store.dispatch('auth/login', newUser.token)
  }

  let cartorioObj = cartorios.find(cartorio => cartorio.user_id === userId)

  if (!cartorioObj) {
    return displayMessage('error', 'Erro', 'Objeto do cartorio não encontrado')
  }

  store.dispatch('auth/setCartorioId', cartorioObj.cartorio_id)

  store.dispatch('auth/setPrimeiroAcesso', cartorioObj.primeiro_acesso)

  store.dispatch('auth/setCartorioObj', cartorioObj)

  store.dispatch('auth/setUserCartorios', cartorios)

  // selecionamos o cartorio da sessao no back.
  await CartorioService.selecionarServentia()

  return true
}
